import ATable, { ATableHeader } from '../../../../organisms/ATable';
import { HistoryEvent } from '../../../../../services/eventingApi';
import EventRow from './EventRow';

const HEADER_CLASS = 'border-b px-2 text-left';

const HEADERS: ATableHeader[] = [
  { id: 'select', title: '', canSort: false, cssClass: HEADER_CLASS, width: '30px' },
  { id: 'occurredAt', title: 'occurredAt', canSort: false, cssClass: HEADER_CLASS },
  { id: 'eventType', title: 'eventType', canSort: false, cssClass: HEADER_CLASS },
  { id: 'delivery', title: 'delivery', canSort: false, cssClass: HEADER_CLASS },
  { id: 'aggregateId', title: 'aggregateId', canSort: false, cssClass: HEADER_CLASS },
  { id: 'version', title: 'versão', canSort: false, cssClass: HEADER_CLASS },
  { id: 'eventId', title: 'eventId', canSort: false, cssClass: HEADER_CLASS },
];

interface EventsTableProps {
  events: HistoryEvent[];
  selected: Set<string>;
  onToggle: (eventId: string) => void;
  onOpen: (event: HistoryEvent) => void;
}

const EventsTable = ({ events, selected, onToggle, onOpen }: EventsTableProps) => (
  <ATable headers={HEADERS}>
    {events.map((event) => (
      <EventRow
        key={`${event.message.eventId}-${event.publishedAt}`}
        event={event}
        selected={selected.has(event.message.eventId)}
        onToggle={() => onToggle(event.message.eventId)}
        onOpen={() => onOpen(event)}
      />
    ))}
  </ATable>
);

export default EventsTable;
